import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
    postCall,
    deleteCall,
    getById,
    BASE_URL,
    getCall, putCall,
} from "../../utils/api";
import axios from "axios";
import toast from "react-hot-toast";

const initialState = {
    data: [],
    error: "",
    status: "idle",
    isUpdateStatus: "idle",
};

export const getWelcomeMessage = createAsyncThunk(
    "welcomeMessage/get",
    async ({ query = "", page = 1, per_page = 50 }) => {
        try {
            const response = await getCall(
                `/admin/v1/welcome-boxes?query=${query}&page=${page}&per_page=${per_page}`,
                false
            );
            return response;
        } catch (error) {
            return Promise?.reject(error);
        }
    }
);

export const getWelcomeMessageById = createAsyncThunk(
    "welcomeMessage/getById",
    async (id) => {
        try {
            const response = await getById(`/admin/v1/hero-banners/${id}`, false);
            return await response;
        } catch (error) {
            return Promise?.reject(error);
        }
    }
);

export const addWelcomeMessage = createAsyncThunk(
    "welcomeMessage/add",
    async (formData) => {
        try {
            return await postCall("/admin/v1/welcome-boxes", formData);
        } catch (error) {
            return Promise?.reject(error);
        }
    }
);

export const updateWelcomeMessage = createAsyncThunk(
    "welcomeMessage/update",
    async ({ id, formData }) => {
        try {
            return await putCall(`/admin/v1/welcome-boxes/${id}`, formData, true);
        } catch (error) {
            return Promise?.reject(error);
        }
    }
);

export const deleteWelcomeMessage = createAsyncThunk(
    "welcomeMessage/delete",
    async (id) => {
        try {
            const response = await deleteCall(`/admin/v1/welcome-boxes/${id}`);
            return {...response, id};
        } catch (error) {
            return Promise?.reject(error);
        }
    }
);

const WelcomeMessageSlice = createSlice({
    name: "welcomeMessage",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getWelcomeMessage.pending, (state) => {
                state.status = "loading";
            })
            .addCase(getWelcomeMessage.fulfilled, (state, action) => {
                state.status = "succeeded";
                state.data = action.payload;
            })
            .addCase(getWelcomeMessage.rejected, (state, action) => {
                state.status = "failed";
                state.error = action.error.message || "An unknown error occurred";
            })
            .addCase(getWelcomeMessageById.pending, (state) => {
                state.status = "loading";
            })
            .addCase(getWelcomeMessageById.rejected, (state, action) => {
                state.status = "failed";
                state.error = action.error.message || "An unknown error occurred";
            })
            .addCase(getWelcomeMessageById.fulfilled, (state, action) => {
                state.status = "succeeded";
                state.outletDetail = action.payload;
            })
            .addCase(addWelcomeMessage.pending, (state) => {
                state.status = "loading";
                state.error = null;
            })
            .addCase(addWelcomeMessage.fulfilled, (state, action) => {
                state.status = "succeeded";
                state.data.data.welcome_boxes.push(action.payload.data);
            })
            .addCase(addWelcomeMessage.rejected, (state, action) => {
                state.status = "failed";
                state.error = action.error.message || "An unknown error occurred";
            })
            .addCase(updateWelcomeMessage.pending, (state) => {
                state.isUpdateStatus = "loading";
                state.error = null;
            })
            .addCase(updateWelcomeMessage.fulfilled, (state, action) => {
                state.isUpdateStatus = "succeeded";
                state.data.data.welcome_boxes = state.data.data.welcome_boxes.map(item =>
                    item.id === action.payload.data.id ? action.payload.data : item
                );
            })
            .addCase(updateWelcomeMessage.rejected, (state, action) => {
                state.isUpdateStatus = "failed";
                state.error = action.error.message || "An unknown error occurred";
            })
            .addCase(deleteWelcomeMessage.pending, (state) => {
                state.status = "loading";
                state.error = null;
            })
            .addCase(deleteWelcomeMessage.fulfilled, (state, action) => {
                state.status = "succeeded";
                state.data.data.welcome_boxes = state.data.data.welcome_boxes.filter(item =>
                    item.id !== action.payload.id
                );
            })
            .addCase(deleteWelcomeMessage.rejected, (state, action) => {
                state.status = "failed";
                state.error = action.error.message || "An unknown error occurred";
            });
    },
});

export default WelcomeMessageSlice.reducer;
